import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateAgencyUserRequest extends BaseUpdateRequest {
	name = '';  
	agencyUserIds: string[] = [];	
}